import cx from 'classnames';
import { At } from 'phosphor-react';

import { Alert } from 'components/shared/Alert';
import { CalendarDots } from 'components/shared/Icon/phosphorIcons';
import Text from 'components/shared/Typography/Text';

import { EDetailsMode } from '../types';
import { chronological, footerText, headerTitle, original } from './ItineraryBuilderSwitch.constants';
import s from './ItineraryBuilderSwitch.module.css';
import * as t from './ItineraryBuilderSwitch.types';

export const ItineraryBuilderSwitch = (props: t.ItineraryBuilderSwitchProps) => {
  return (
    <>
      <div className={s.header}>{headerTitle}</div>
      <div className={s.options}>
        <BuilderModeOption
          renderIcon={() => <CalendarDots className={cx(s.optionIcon, s.calendarIcon)} />}
          title={chronological.title}
          subtitle={chronological.subtitle}
          list={chronological.list}
          onClick={() => props.onOptionClick(EDetailsMode.Chronological)}
        />
        <BuilderModeOption
          renderIcon={() => <At className={cx(s.optionIcon, s.atIcon)} />}
          title={original.title}
          subtitle={original.subtitle}
          list={original.list}
          onClick={() => props.onOptionClick(EDetailsMode.Original)}
        />
      </div>
      <div className={s.footer}>
        <Alert variant="info" content={footerText} className={s.alert} />
      </div>
    </>
  );
};

const BuilderModeOption = (props: t.BuilderModeOptionProps) => {
  return (
    <div className={s.option} onClick={props.onClick}>
      <div className={s.optionIcon}>{props.renderIcon()}</div>

      <Text type="brandon" size="regular" isStrong className={s.optionTitle}>
        {props.title}
      </Text>

      <Text type="brandon" size="regular" color="gray-600">
        {props.subtitle}
      </Text>

      <ul className={s.optionList}>
        {props.list.map((item, index) => (
          <li key={index} className={s.optionListItem}>
            <Text isStrong italic color="gray-600" className={s.optionListItemBullet}>
              &#183;
            </Text>
            <Text type="brandon" size="regular" color="gray-600" italic>
              {item}
            </Text>
          </li>
        ))}
      </ul>
    </div>
  );
};
